import { useEffect, useRef, useState } from "react";

export const useLocalStorage = <T>(key: string, initialValue: T) => {
  const [value, setValue] = useState(initialValue);

  const isMounted = useRef(false);

  useEffect(() => {
    const item = localStorage.getItem(key);

    if (item) {
      setValue(JSON.parse(item));
    }
  }, [key]);

  useEffect(() => {
    if (isMounted.current) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }, [value, key]);

  useEffect(() => {
    isMounted.current = true;
  }, []);

  return [value, setValue] as const;
};

export const clearAllStorage = () => {
  localStorage.clear();
  sessionStorage.clear();
  // Optionally, you can also clear cookies if needed
  document.cookie.split(";").forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
};
